(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-table-of-content-blog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-item').forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('active');
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('.toc-toggle');
    const list = document.querySelector('.toc-list');

    if (toggle && list) {
      toggle.addEventListener('click', function () {
        toggle.classList.toggle('open');
        list.classList.toggle('active');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-table-of-content-npa"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tocSection = document.querySelector('.npa-accordion-toc');
    if (!tocSection) return;

    const headers = tocSection.querySelectorAll('.toc-accordion-header');
    const mainAccordion = tocSection.querySelector('.toc-accordion');
    const mainToggle = tocSection.querySelector('.toc-main-heading');

    /* ===============================
     INNER ACCORDION (ALL DEVICES)
  ================================ */
    headers.forEach((header) => {
      header.addEventListener('click', function () {
        const item = this.closest('.toc-accordion-item');
        const body = item.querySelector('.toc-accordion-body');
        const isOpen = item.classList.contains('active');

        if (isOpen) {
          item.classList.remove('active');
          body.style.maxHeight = null;
        } else {
          item.classList.add('active');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    /* ===============================
     MAIN ACCORDION (MOBILE ONLY)
  ================================ */
    if (window.innerWidth > 768) return;
    if (!mainAccordion || !mainToggle) return;

    // Start collapsed on mobile
    mainAccordion.classList.add('is-collapsed');

    mainToggle.addEventListener('click', function () {
      mainToggle.classList.toggle('open');
      mainAccordion.classList.toggle('is-collapsed');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-table-of-content"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-item').forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('active');
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('.toc-toggle');
    const list = document.querySelector('.toc-list');

    if (toggle && list) {
      toggle.addEventListener('click', function () {
        toggle.classList.toggle('open');
        list.classList.toggle('active');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sitewide-unsupported-country-modal"]) return;
  try {
    
  (function() {
    var dialog = document.querySelector('[data-unsupported-country-modal]');

    if (!dialog) return;

    var sectionId = dialog.getAttribute('data-section-id') || 'global';
    var closeButton = dialog.querySelector('[data-unsupported-country-modal-close]');
    var partnerLinks = dialog.querySelectorAll('[data-unsupported-country-modal-partner]');
    var supportedCountriesValue = dialog.getAttribute('data-supported-countries') || '';
    var isThemeEditor = !!(window.Shopify && window.Shopify.designMode);
    var searchParams = new URLSearchParams(window.location.search);
    var previewCountryCode = (searchParams.get('unsupported_country_modal_country') || '').trim().toUpperCase();
    var countryCode = previewCountryCode || (dialog.getAttribute('data-country-code') || '').toUpperCase();
    var forceShow = ['1', 'true', 'yes'].indexOf((searchParams.get('unsupported_country_modal_force') || '').toLowerCase()) !== -1;
    var storageKey = ['unsupported-country-modal-session', sectionId, countryCode || 'unknown'].join(':');

    function parseCountries(value) {
      return value.split(',').map(function(item) {
        return item.trim().toUpperCase();
      }).filter(Boolean);
    }

    function hasDismissedThisSession() {
      try {
        return window.sessionStorage.getItem(storageKey) === 'dismissed';
      } catch (error) {
        return false;
      }
    }

    function setSessionDismissed() {
      try {
        window.sessionStorage.setItem(storageKey, 'dismissed');
      } catch (error) {
      }
    }

    function isSupportedCountry(code, supportedCountries) {
      return supportedCountries.indexOf(code) !== -1;
    }

    function shouldShow() {
      var supportedCountries = parseCountries(supportedCountriesValue);

      if (isThemeEditor) return true;
      if (forceShow) return true;
      if (!countryCode) return false;
      if (isSupportedCountry(countryCode, supportedCountries)) return false;

      return !hasDismissedThisSession();
    }

    function closeDialog(shouldPersist) {
      if (shouldPersist) {
        setSessionDismissed();
      }

      if (dialog.open) {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      }

      document.documentElement.classList.remove('unsupported-country-modal-open');
    }

    function openDialog() {
      if (dialog.open) return;

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', 'open');
      }

      document.documentElement.classList.add('unsupported-country-modal-open');
    }

    if (closeButton) {
      closeButton.addEventListener('click', function() {
        closeDialog(!isThemeEditor);
      });
    }

    dialog.addEventListener('cancel', function(event) {
      event.preventDefault();
      closeDialog(!isThemeEditor);
    });

    dialog.addEventListener('click', function(event) {
      if (event.target === dialog) {
        closeDialog(!isThemeEditor);
      }
    });

    Array.prototype.forEach.call(partnerLinks, function(link) {
      link.addEventListener('click', function() {
        if (!isThemeEditor) {
          setSessionDismissed();
        }
      });
    });

    if (isThemeEditor) {
      document.addEventListener('shopify:section:select', function(event) {
        if (event.detail.sectionId === sectionId) {
          openDialog();
        }
      });

      document.addEventListener('shopify:section:deselect', function(event) {
        if (event.detail.sectionId === sectionId) {
          closeDialog(false);
        }
      });
    }

    if (shouldShow()) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', openDialog, { once: true });
      } else {
        openDialog();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
